module.exports = __webpack_public_path__ + "static/media/404.a2867073.gif";